var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon5",
    transform: "translate(-480 -678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4856",
    "data-name": "\\uC0AC\\uAC01\\uD615 4856",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 678)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(489 629.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56377",
    "data-name": "\\uADF8\\uB8F9 56377",
    transform: "translate(0 61.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33670",
    "data-name": "\\uD328\\uC2A4 33670",
    d: "M11.679,61.8.016,68.783,0,74.72,20.321,86.8l11.663-6.98L32,73.886Z",
    transform: "translate(0 -61.803)",
    fill: "#378b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33671",
    "data-name": "\\uD328\\uC2A4 33671",
    d: "M336.814,249.52l-.016,5.765-11.663,6.778.016-5.765Z",
    transform: "translate(-304.814 -237.062)",
    fill: "#378b4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33672",
    "data-name": "\\uD328\\uC2A4 33672",
    d: "M20.337,181.977l-.016,5.765L0,176.01l.016-5.765Z",
    transform: "translate(0 -100.939)",
    fill: "#40a559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33673",
    "data-name": "\\uD328\\uC2A4 33673",
    d: "M32.245,74,20.582,81.038.261,68.846,11.924,61.8Z",
    transform: "translate(-0.245)",
    fill: "#4dba69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33674",
    "data-name": "\\uD328\\uC2A4 33674",
    d: "M83.607,96.93a1.261,1.261,0,0,1,.557-.574l0-.576-15.3-8.836a3.306,3.306,0,0,1-3,0l-6.678,3.881.076.046-.076-.046,0,.576a1.271,1.271,0,0,1,.568.587,1.261,1.261,0,0,1-.557.575l0,.576,15.3,8.836a3.305,3.305,0,0,1,3,0l6.678-3.881,0-.576A1.269,1.269,0,0,1,83.607,96.93Zm-15.66-4.336a8.194,8.194,0,0,1,7.435,0,2.814,2.814,0,0,1,1.529,1.879,2.791,2.791,0,0,1-1.5,1.851,8.193,8.193,0,0,1-7.435,0,2.811,2.811,0,0,1-1.529-1.882A2.793,2.793,0,0,1,67.948,92.594Z",
    transform: "translate(-55.482 -23.569)",
    fill: "#d2edda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56378",
    "data-name": "\\uADF8\\uB8F9 56378",
    transform: "translate(3.699 67.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33675",
    "data-name": "\\uD328\\uC2A4 33675",
    d: "M59.809,149.916l0,.576a1.062,1.062,0,0,0-.626-.875l0-.576A1.062,1.062,0,0,1,59.809,149.916Z",
    transform: "translate(-59.181 -149.041)",
    fill: "#addfba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33676",
    "data-name": "\\uD328\\uC2A4 33676",
    d: "M185.524,156.918l0,.576a2.63,2.63,0,0,0-1.552-2.168,8.193,8.193,0,0,0-7.435,0,2.611,2.611,0,0,0-1.528,2.138l0-.576a2.611,2.611,0,0,1,1.528-2.138,8.194,8.194,0,0,1,7.435,0A2.631,2.631,0,0,1,185.524,156.918Z",
    transform: "translate(-167.769 -153.557)",
    fill: "#addfba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56379",
    "data-name": "\\uADF8\\uB8F9 56379",
    transform: "translate(22.013 72.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33677",
    "data-name": "\\uD328\\uC2A4 33677",
    d: "M449.046,229.761l0-.576a1.054,1.054,0,0,1,.617-.863l0,.576A1.054,1.054,0,0,0,449.046,229.761Z",
    transform: "translate(-442.994 -228.322)",
    fill: "#94d6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33678",
    "data-name": "\\uD328\\uC2A4 33678",
    d: "M358.891,256.125l0,.576-6.678,3.881,0-.576Z",
    transform: "translate(-352.211 -254.387)",
    fill: "#94d6a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33679",
    "data-name": "\\uD328\\uC2A4 33679",
    d: "M74.643,185.681l0,.576-15.3-8.836,0-.577Z",
    transform: "translate(-55.628 -107.501)",
    fill: "#addfba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33680",
    "data-name": "\\uD328\\uC2A4 33680",
    d: "M307.213,312.824l0,.576a3.306,3.306,0,0,0-3,0l0-.576A3.305,3.305,0,0,1,307.213,312.824Z",
    transform: "translate(-285.198 -234.508)",
    fill: "#94d6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33681",
    "data-name": "\\uD328\\uC2A4 33681",
    d: "M84.189,95.779a.918.918,0,0,0,.01,1.738L77.521,101.4a3.306,3.306,0,0,0-3,0l-15.3-8.836a.918.918,0,0,0-.01-1.738l6.679-3.881a3.306,3.306,0,0,0,3,0ZM68,96.324a8.192,8.192,0,0,0,7.435,0c2.046-1.189,2.036-3.118-.024-4.307a8.194,8.194,0,0,0-7.435,0c-2.046,1.189-2.036,3.117.024,4.307",
    transform: "translate(-55.506 -23.569)",
    fill: "#d2edda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33685",
    "data-name": "\\uD328\\uC2A4 33685",
    d: "M223.683,192.361l0-.922a.048.048,0,0,1,0-.01l0,.922A.061.061,0,0,0,223.683,192.361Z",
    transform: "translate(-209.703 -121.273)",
    fill: "#d2edda"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon5);
export default __webpack_public_path__ + "static/media/sec1Icon5.e70db7b2c10188274ca3bda3af35af6b.svg";
export { ForwardRef as ReactComponent };